

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

const getListData = (response) => {
  return response.data?.data?.data || [];
};

const getSubmitConfig = (payload) => {
  if (payload instanceof FormData) {
    return {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
  }

  return undefined;
};

const getSponsorErrorMessage = (error) => {
  const data = error?.response?.data;

  if (typeof data === "string") {
    return data;
  }

  if (typeof data?.messages === "string") {
    return data.messages;
  }

  if (data?.messages && typeof data.messages === "object") {
    if (typeof data.messages.name === "string") {
      return data.messages.name;
    }

    const firstMessage = Object.values(data.messages).find(
      (value) => typeof value === "string" && value
    );

    if (firstMessage) {
      return firstMessage;
    }
  }

  if (typeof data?.message === "string") {
    return data.message;
  }

  return "Đã xảy ra lỗi!";
};

export const fetchSponsors = createAsyncThunk(
  "sponsors/fetchSponsors",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get("sponsor-show", { params });
      return getListData(response);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

export const fetchPublicSponsors = createAsyncThunk(
  "sponsors/fetchPublicSponsors",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get("sponsor-public-show", { params });
      return getListData(response);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

export const fetchSponsorPublicById = createAsyncThunk(
  "sponsors/fetchSponsorPublicById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get(`/sponsor-public-show/${id}`);
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

export const createSponsor = createAsyncThunk(
  "sponsors/createSponsor",
  async (newSponsor, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post(
        "/sponsor-create",
        newSponsor,
        getSubmitConfig(newSponsor)
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getSponsorErrorMessage(error));
    }
  }
);

export const updateSponsor = createAsyncThunk(
  "sponsors/updateSponsor",
  async ({ id, newSponsor }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(
        `/sponsor-update/${id}`,
        newSponsor,
        getSubmitConfig(newSponsor)
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getSponsorErrorMessage(error));
    }
  }
);

export const deleteSponsor = createAsyncThunk(
  "sponsors/deleteSponsor",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(`/sponsor-delete/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const sponsorSlice = createSlice({
  name: "sponsors",
  initialState: {
    sponsors: [],
    publicSponsors: [],
    currentSponsor: null,
    status: "idle",
    publicStatus: "idle",
    detailStatus: "idle",
    error: null,
    publicError: null,
    detailError: null,
  },
  reducers: {
    clearCurrentSponsor: (state) => {
      state.currentSponsor = null;
      state.detailStatus = "idle";
      state.detailError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSponsors.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSponsors.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sponsors = action.payload;
      })
      .addCase(fetchSponsors.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchPublicSponsors.pending, (state) => {
        state.publicStatus = "loading";
      })
      .addCase(fetchPublicSponsors.fulfilled, (state, action) => {
        state.publicStatus = "succeeded";
        state.publicSponsors = action.payload;
      })
      .addCase(fetchPublicSponsors.rejected, (state, action) => {
        state.publicStatus = "failed";
        state.publicError = action.payload;
      })
      .addCase(fetchSponsorPublicById.pending, (state) => {
        state.detailStatus = "loading";
        state.currentSponsor = null;
      })
      .addCase(fetchSponsorPublicById.fulfilled, (state, action) => {
        state.detailStatus = "succeeded";
        state.currentSponsor = action.payload;
      })
      .addCase(fetchSponsorPublicById.rejected, (state, action) => {
        state.detailStatus = "failed";
        state.detailError = action.payload;
      })
      .addCase(createSponsor.fulfilled, (state) => {
        state.status = "idle";
        state.publicStatus = "idle";
      })
      .addCase(updateSponsor.fulfilled, (state) => {
        state.status = "idle";
        state.publicStatus = "idle";
      })
      .addCase(deleteSponsor.fulfilled, (state) => {
        state.status = "idle";
        state.publicStatus = "idle";
      });
  },
});

export const { clearCurrentSponsor } = sponsorSlice.actions;
export default sponsorSlice.reducer;


